// #ux-redesign: thin wrapper backwards-compatible.
// El componente real es AttachmentChip. BtnFile se queda como adapter para
// no romper otros lugares que lo importan (legacy InboxDetail, etc).
import React from 'react';
import AttachmentChip from 'components/Messages/View/AttachmentChip';

const BtnFile = ({ file }) => <AttachmentChip fileId={file} />;

export default BtnFile;
